// Packages
import { createApp, defineAsyncComponent } from 'vue';
import { initDropdowns } from 'flowbite';

// Vue components
import SearchList from '@vue-components/SearchList.vue';

export default function init(): void {
  // Create Vue instance for people search
  const vueInstance = createApp({
    name: 'SearchIndex',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      SearchList,
      PersonCard: defineAsyncComponent(() => import('@vue-components/cards/PersonCard.vue')),
      TextCard: defineAsyncComponent(() => import('@vue-components/cards/TextCard.vue')),
    },
    mounted() {
      initDropdowns();
    },
  });

  // Mount the app
  vueInstance.mount('#search-index');
}
